// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getMessaging, MessagePayload, onMessage, onRegistered, register } from 'firebase/messaging';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyC7r0k-ZHXltmeqKRiaFEgXK6lTeUNeKBI',
  authDomain: 'awake-45e86.firebaseapp.com',
  projectId: 'awake-45e86',
  storageBucket: 'awake-45e86.firebasestorage.app',
  messagingSenderId: '157815016487',
  appId: '1:157815016487:web:8bf522bb4266efc8cc1202',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

onRegistered(messaging, (installationId) => {
  console.log('Registered installation ID:', installationId);

  // Send the Firebase Installation ID to your app server and update the UI if needed.
});

export const requestPermissionNotification = () => {
  console.log('Requesting permission...');
  Notification.requestPermission().then((permission) => {
    console.log(permission);

    if (permission === 'granted') {
      register(messaging, {
        vapidKey: 'BLoaYFnCIOZJyntMO7NZG53pyPY7Y5hgoU_AmGItoEXwpIDhJfkQMKa-lJMXeGrNuL5FMOOBLUxLNZ5uiq46fL4',
      });
    }
  });
};

export const onMessageListener = (): Promise<MessagePayload> =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log(payload);

      resolve(payload);
    });
  });
